import { render, staticRenderFns } from "./Displayoor.vue?vue&type=template&id=a6462b90&scoped=true&"
import script from "./Displayoor.vue?vue&type=script&lang=ts&"
export * from "./Displayoor.vue?vue&type=script&lang=ts&"
import style0 from "./Displayoor.vue?vue&type=style&index=0&id=a6462b90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6462b90",
  null
  
)

export default component.exports